export default __webpack_public_path__ + "static/media/home02.fded4563.png";